import { send } from '../../../../../../src/network/network';
import { type CustomerTagList } from '../../../../../../src/types/CustomerTagList';
import { type PatchedCustomerTagList } from '../../../../../../src/types/PatchedCustomerTagList';

export { type PatchedCustomerTagList, type CustomerTagList };

type ResponseSchema = CustomerTagList[];

type Params = {
  requestBody: PatchedCustomerTagList[];
};

export async function patchApiV2CustomersCustomerIdTags(params: Params) {
  return await send<ResponseSchema>({
    path: `/api/v2/customers/self/tags/`,
    method: 'PATCH',
    body: params.requestBody,
  });
}
